import React, { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { useAppDispatch, useAppSelector } from "../../../../../../redux/hooks";
import { PopUpForm } from "../../../../../common/popup/popUpForm/popUpForm";

import { PopUpCodes } from "../../../../../../common/enum/PopUpCodes";
import { postToMasterProfileForm } from "../../../../../../redux/actions/resources/master/profiles/profile";
import { setShowPopUpMaster } from "../../../../../../redux/reducers/resources/master/master";
import { resetMasterProfileForm } from "../../../../../../redux/reducers/resources/master/profile/form";
import { RequiredFieldsMessage } from "../../../../../common/requiredMessage/requiredMessage";
import { MasterProfileForm } from "./form/form";
interface IMasterTransportUnitControllerForm {
    widthPopUp: any;
    heigthPopUp: any;
}
export const MasterProfileFormController: React.FC<IMasterTransportUnitControllerForm> = ({ widthPopUp, heigthPopUp }) => {
    const dispatch = useAppDispatch();
    const { t } = useTranslation("common", { keyPrefix: "MASTERS" });

    const { showPopUp } = useAppSelector((state) => state.masterPopUp);
    const { form, loading } = useAppSelector((state) => state.masterProfileForm);

    const onAcceptPopUp = () => {
        dispatch(postToMasterProfileForm()).then((response: any) => {
            if (response) {
                onCancelPopUp();
            }
        });
    };

    const onCancelPopUp = () => {
        dispatch(setShowPopUpMaster(PopUpCodes.NONE));
    };

    const onDimissed = () => {
        dispatch(resetMasterProfileForm());
    };
    const titlePopUp = useMemo(() => {
        let title = "";
        if (showPopUp === PopUpCodes.CREATE) {
            title = t("CREATE") + " " + t("BUTTON.PROFILES");
        } else if (showPopUp === PopUpCodes.UPDATE) {
            title = t("UPDATE") + " " + t("BUTTON.PROFILES");
        }
        return title;
    }, [showPopUp]);

    const isDisabledButton = useMemo(() => {
        return !form.code || !form.description;
    }, [form]);

    return (
        <PopUpForm
            content={<MasterProfileForm />}
            title={titlePopUp}
            isVisible={showPopUp === PopUpCodes.CREATE || showPopUp === PopUpCodes.UPDATE ? true : false}
            onCancel={onCancelPopUp}
            onSave={onAcceptPopUp}
            height={heigthPopUp}
            width={widthPopUp}
            isDisabledButton={isDisabledButton}
            isLoading={loading}
            onDimissed={onDimissed}
            leftButtonContent={<RequiredFieldsMessage />}
        />
    );
};
